import * as React from "react";
import {useAuthStore} from "@Stores";

export const usePermissions = (permissionLabels: string[]) => {
  const {appSecurityModel, permissions} = useAuthStore();

  const [isHasPermissions, setIsHasPermissions] = React.useState<Record<string, boolean>>({});

  const  resolvePermissions = React.useCallback( () => {

    const getPermission = (label: string) =>
      permissions?.find?.(it => it.label === label);
    const permissionChecks = permissionLabels.map( label => {
        const hasPermission = getPermission(label);
        if (!hasPermission) return [label, false];

        return [label, hasPermission] as const;
      })

    const permissionResults = Object.fromEntries(permissionChecks);
    setIsHasPermissions(permissionResults);
  }, [permissionLabels, permissions]);

  React.useEffect(() => {
    if (appSecurityModel?.hasPrincipalApplicationAdministration) {
      const adminPermissions = Object.fromEntries(
        permissionLabels.map(label => [label, true])
      );
      setIsHasPermissions(adminPermissions);
    } else {
      resolvePermissions();
    }
  }, []);

  return { isHasPermissions };
};
